/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneBanner from 'sites/allas/components/standalone/Banner';

export const DynamicStandaloneBanner = StandaloneBanner;
export type DynamicStandaloneBannerProps = PropsFromComponent<typeof StandaloneBanner>;

export const DynamicStandaloneBannerWith = (extras: DynamicStandaloneExtras): typeof StandaloneBanner => {
    return function DynamicStandaloneBanner(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Banner');
        return <StandaloneBanner {...mergeProps({ options: { theme } }, props)} />;
    }
}